import { Suspense, lazy } from 'react'

import Title from '@components/Shared/Title'

const Downloads = lazy(() =>
  import(
    /*webpackPreload: true */ /* webpackChunkName: "Downloads" */ '@components/Downloads'
  )
)

const Footer = lazy(() =>
  import(
    /*webpackPreload: true */ /* webpackChunkName: "Footer" */ '@components/Shared/Footer'
  )
)

const PopularPackages = lazy(() =>
  import(
    /*webpackPreload: true */ /* webpackChunkName: "PopularPackages" */ '@components/PopularPackages'
  )
)

const SearchBar = lazy(() =>
  import(
    /*webpackPreload: true */ /* webpackChunkName: "SearchBar" */ '@components/Shared/SearchBar'
  )
)

function App() {
  return (
    <div className='container mx-auto p-4'>
      <Title />
      <Suspense fallback={null}>
        <SearchBar />
      </Suspense>
      <Suspense fallback={null}>
        <Downloads />
      </Suspense>
      <Suspense fallback={null}>
        <PopularPackages />
      </Suspense>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default App
